import React, { useEffect } from 'react';
import './App.css';
import { Routes, Route } from "react-router-dom";
import Home from './views/home';
import TrackOrder from './views/trackOrder';
import NewRequest from './views/newRequest';
import ValidateAccount from './views/validateAccount/index';
import UnauthorizedUser from './views/unauthorizedUser';
import HeaderComponent from './components/HeaderComponent';
import { getSessionData, updateManifestFile } from './utils/utils';
import PushNotificationTest from './PushNotificationTest';
function App() {
  const accountId = getSessionData('userID');
  const uniqueCode = getSessionData('token');

  useEffect(() => {
    if (accountId && uniqueCode) {
      updateManifestFile(accountId, uniqueCode);
    }
  }, [accountId, uniqueCode]);

  return (
    <div className="App">
      <HeaderComponent />
      <PushNotificationTest />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="newrequest" element={<NewRequest />} />
        <Route path="trackOrder" element={<TrackOrder />} />
        <Route path="validateAcct/:accountId/:uniqueCode" element={<ValidateAccount />} />
        <Route path="unauthorizedUser" element={<UnauthorizedUser />} />
      </Routes>
    </div>
  );
}

export default App;